import React from 'react';
import styled from '@emotion/styled';
import Page from '../../../components/Page/Page';
import JobsSegment from './JobsSegment';
import PageBanner from '../../../components/Banner/PageBanner';

const Jobs = () => {
  return (
    <Page title="Locum Health | Your Jobs">
      <Container>
        <PageBanner label="Jobs" description="Here are jobs you have posted" />
        <JobsSegment />
      </Container>
    </Page>
  );
};

export default Jobs;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;

  @media (max-width: 480px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
